import {
  ALPHANUMERIC_REGEX,
  ALPHANUMERIC_WITH_SPECIAL_REGEX,
} from 'views/AddLocations/constants';
import { object, string, number } from 'yup';
import { PostalCodeError } from './companySetupConstants';
import provinceValidation from 'shared/utils/provinceValidation';

export const orgValidationSchema = object().shape({
  organizationName: string()
    .required('Organization Name is required')
    .matches(
      ALPHANUMERIC_WITH_SPECIAL_REGEX,
      'Organization Name must be alphanumeric includes @&*,.":;'
    )
    .max(30, 'Organization Name must be at most 30 characters'),

  organizationSize: string().required('Organization Size is required'),
  sector: string().required('Sector is required').nullable(),
  companyType: string().required('Company Type is required').nullable(),
});
export const reportingValidationSchema = object().shape({
  startOfReportingYear: string().required(
    'Start of the Reporting Year is required'
  ),
  baselineYear: string().required('Baseline Year is required'),
  recalculationThreshold: number()
    .required('Baseline Year Recalculation Threshold is required')
    .max(100, 'Recalculation Threshold must be less than or equal to 100')
    .min(0, 'Recalculation Threshold must be greater than or equal to 0'),
});
export const REQUIREDTEXT = 'Required';
export const locationValidationSchema = object({
  name: string().required(REQUIREDTEXT),
  category: string().required(REQUIREDTEXT),
  city: string().required(REQUIREDTEXT),
  street: string().required(REQUIREDTEXT),
  country: string().required(REQUIREDTEXT),
  postalCode: string().matches(ALPHANUMERIC_REGEX, PostalCodeError).nullable(),
  countryCode: string().required(REQUIREDTEXT),
  province: provinceValidation,
});
